import { lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import ViewerPage from "./viewer/ViewerPage.jsx";
import PublishWatcher from "./viewer/PublishWatcher.jsx";

// The admin is code-split off the viewer (item 0315). A totem or a phone that
// scanned a QR only ever runs /id/:slug, and used to download, parse and keep
// in memory the whole editor with it: terra-draw, polygon-clipping, every admin
// view and the 119 KB admin string table -- about a sixth of the main chunk.
// The viewer stays a static import so the public path has no extra round trip.
const AdminLayout = lazy(() => import("./admin/AdminLayout.jsx"));
const CategoriesView = lazy(() => import("./admin/CategoriesView.jsx"));
const EditorView = lazy(() => import("./admin/EditorView.jsx"));
const FloorsView = lazy(() => import("./admin/FloorsView.jsx"));
const ImportView = lazy(() => import("./admin/ImportView.jsx"));
const KiosksView = lazy(() => import("./admin/KiosksView.jsx"));
const Login = lazy(() => import("./admin/Login.jsx"));
const NewVenueView = lazy(() => import("./admin/NewVenueView.jsx"));
const PoisView = lazy(() => import("./admin/PoisView.jsx"));
const VenuesView = lazy(() => import("./admin/VenuesView.jsx"));
const VersionsView = lazy(() => import("./admin/VersionsView.jsx"));

export default function App() {
  return (
    <Suspense fallback={null}>
    <Routes>
      <Route
        path="/id/:slug"
        element={
          <>
            <ViewerPage />
            {/* Item 0375: screens reload onto a new publish; preview ribbon. */}
            <PublishWatcher />
          </>
        }
      />
      <Route path="/admin/login" element={<Login />} />
      <Route path="/admin" element={<AdminLayout />}>
        <Route index element={<Navigate to="venues" replace />} />
        <Route path="venues" element={<VenuesView />} />
        {/* Explicit create surface. Reachable with any number of venues,
            including zero — see NewVenueView. */}
        <Route path="new" element={<NewVenueView />} />
        <Route path="floors" element={<FloorsView />} />
        <Route path="categories" element={<CategoriesView />} />
        <Route path="pois" element={<PoisView />} />
        <Route path="kiosks" element={<KiosksView />} />
        <Route path="editor" element={<EditorView />} />
        <Route path="import" element={<ImportView />} />
        <Route path="versions" element={<VersionsView />} />
      </Route>
      <Route path="*" element={<Navigate to="/id/marina-port-premia" replace />} />
    </Routes>
    </Suspense>
  );
}
